export default __webpack_public_path__ + "static/media/news_1.9cb9bee8.png";